import { TuiButtonModule } from '@taiga-ui/core';
import { TuiLetModule } from '@taiga-ui/cdk';
import { TuiAppBarModule } from '@taiga-ui/addon-mobile';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';

import { CustomerNamePipe, ServiceLocationNamePipe, SiteNamePipe } from '@iss/wo-common/pipes';
import { FileHashPipe } from '@iss/wo-common/hash-files';
import { LabelledFieldComponent } from '@iss/wo-common/components';

@Component({
  selector: 'wo-page-mobile-app-bar',
  templateUrl: './page-mobile-app-bar.component.html',
  styleUrls: [ './page-mobile-app-bar.component.scss' ],
  standalone: true,
  imports: [
    AsyncPipe,
    CustomerNamePipe,
    FileHashPipe,
    LabelledFieldComponent,
    NgIf,
    ServiceLocationNamePipe,
    SiteNamePipe,
    TuiAppBarModule,
    TuiButtonModule,
    TuiLetModule,
  ],
})
export class PageMobileAppBarComponent {
  @Input({ required: true }) public header!: string;
  @Output() public readonly toggle = new EventEmitter<void>();
}
